import { useState, useEffect } from 'react';
import { 
  collection, 
  query, 
  where, 
  getDocs, 
  addDoc, 
  deleteDoc,
  doc 
} from 'firebase/firestore';
import { db } from '../firebase';
import { Table, Button, Form, Container, Alert } from 'react-bootstrap';

export default function AdminPanel() {
  const [email, setEmail] = useState('');
  const [admins, setAdmins] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'admins'));
      setAdmins(querySnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data() 
      })));
    } catch (error) {
      setMessage('Error loading admins: ' + error.message);
    }
  };

  const handleAddAdmin = async (e) => {
    e.preventDefault();
    try {
      // Find user by email
      const usersQuery = query(
        collection(db, 'users'), 
        where('email', '==', email)
      );
      const usersSnapshot = await getDocs(usersQuery);
      
      if (usersSnapshot.empty) {
        throw new Error('No user found with this email');
      }

      const userDoc = usersSnapshot.docs[0];
      
      // Add to admins collection
      await addDoc(collection(db, 'admins'), {
        uid: userDoc.id,
        email: email,
        createdAt: new Date()
      });
      
      setEmail('');
      setMessage('Admin added successfully');
      fetchAdmins();
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleRemoveAdmin = async (adminId) => {
    if (window.confirm('Are you sure you want to remove this admin?')) {
      try {
        await deleteDoc(doc(db, 'admins', adminId));
        setMessage('Admin removed successfully');
        fetchAdmins();
      } catch (error) {
        setMessage('Error removing admin: ' + error.message);
      }
    }
  };

  return (
    <Container className="mt-5">
      <h2>Admin Management</h2>
      {message && <Alert variant={message.includes('Error') ? 'danger' : 'success'}>{message}</Alert>}

      <Form onSubmit={handleAddAdmin} className="mb-4">
        <Form.Group>
          <Form.Label>Add Admin by Email</Form.Label>
          <div className="d-flex gap-2">
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter user email"
              required
            />
            <Button variant="primary" type="submit">
              Add Admin
            </Button>
          </div>
        </Form.Group>
      </Form>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {admins.map(admin => (
            <tr key={admin.id}>
              <td>{admin.email}</td>
              <td>
                <Button 
                  variant="danger" 
                  onClick={() => handleRemoveAdmin(admin.id)}
                  disabled={admins.length <= 1}
                >
                  Remove
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}